import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanLoad,
    UrlSegment,
    UrlTree, Route
} from '@angular/router';
import { Store } from '../store';
import { CookieService } from '../services/cookie.service';
import { StorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

    constructor(
        private store: Store,
        private router: Router,
        private cookieService: CookieService,
        private storageService: StorageService,
    ) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.isAuthenticated();
    }

    canLoad(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
        return this.isAuthenticated();
    }

    private async isAuthenticated(): Promise<boolean | UrlTree>
    {
        const res = await this.cookieService.isAuthenticated();
        if (res) {
            return true;
        } else {
            this.router.navigate(['/']);
        }
    }
}
